/* dokaLab retail partners — shared by Find Us page + home page map */
window.DOKA_STORES = [
{
  name: "Hoogstins Bookstore",
  address: "Kinkerstraat 117, 1053 DL Amsterdam",
  mapsLink: "https://www.google.com/maps?q=Hoogstins+Bookstore,+Kinkerstraat+117,+1053+DL+Amsterdam",
  country: "netherlands", countryLabel: "Netherlands",
  lat: 52.366202, lng: 4.868507
},
{
  name: "Stedelijk Museum",
  address: "Museumplein 10, 1071 DJ Amsterdam",
  mapsLink: "https://www.google.com/maps?q=Stedelijk+Museum,+Museumplein+10,+1071+DJ+Amsterdam",
  country: "netherlands", countryLabel: "Netherlands",
  lat: 52.358416, lng: 4.881076
},
{
  name: "Foam",
  address: "Keizersgracht 609, 1017 DS Amsterdam",
  mapsLink: "https://www.google.com/maps?q=Foam,+Keizersgracht+609,+1017+DS+Amsterdam",
  country: "netherlands", countryLabel: "Netherlands",
  lat: 52.363621, lng: 4.891442
},
{
  name: "Huis Marseille",
  address: "Keizersgracht 401, 1016 EK Amsterdam",
  mapsLink: "https://www.google.com/maps?q=Huis+Marseille,+Keizersgracht+401,+1016+EK+Amsterdam",
  country: "netherlands", countryLabel: "Netherlands",
  lat: 52.370885, lng: 4.884197
},
{
  name: "Le Reservoir",
  address: "30 Grand-Rue, 1660 Ville-Haute, Luxembourg",
  mapsLink: "https://www.google.com/maps?q=Le+Reservoir,+30+Grand-Rue,+1660+Ville-Haute+Luxembourg",
  country: "luxembourg", countryLabel: "Luxembourg",
  lat: 49.611294, lng: 6.131935
},
{
  name: "The Maker Store",
  address: "Hannie Dankbaarpassage 39, 1053 RT Amsterdam",
  mapsLink: "https://www.google.com/maps?q=The+Maker+Store,+Hannie+Dankbaarpassage+39,+1053+RT+Amsterdam",
  country: "netherlands", countryLabel: "Netherlands",
  lat: 52.3625, lng: 4.8830
},
{
  name: "Dominos - Jouets",
  address: "6 Rue Louvigny, 1946 Ville-Haute Luxembourg",
  mapsLink: "https://www.google.com/maps?q=Dominos+-+Jouets,+6+Rue+Louvigny,+1946+Ville-Haute+Luxembourg",
  country: "luxembourg", countryLabel: "Luxembourg",
  lat: 49.6115, lng: 6.1315
},
{
  name: "Grobet",
  address: "Eiermarkt 25, 2000 Antwerpen, Belgium",
  mapsLink: "https://www.google.com/maps?q=Grobet,+Eiermarkt+25,+2000+Antwerpen+Belgium",
  country: "belgium", countryLabel: "Belgium",
  lat: 51.220620, lng: 4.404430
},
{
  name: "Museum of Contemporary Art M HKA",
  address: "Leuvenstraat 32, 2000 Antwerpen, Belgium",
  mapsLink: "https://www.google.com/maps?q=Museum+of+Contemporary+Art+M+HKA,+Leuvenstraat+32,+2000+Antwerpen+Belgium",
  country: "belgium", countryLabel: "Belgium",
  lat: 51.214150, lng: 4.403530
},
{
  name: "Foto Mignon",
  address: "Van Woustraat 56, 1073 LN Amsterdam",
  mapsLink: "https://www.google.com/maps?q=Foto+Mignon,+Van+Woustraat+56,+1073+LN+Amsterdam",
  country: "netherlands", countryLabel: "Netherlands",
  lat: 52.352680, lng: 4.907210
},
{
  name: "Bauhaus Archive",
  country: "germany",
  countryLabel: "Germany",
  address: "Klingelhöferstraße 14, 10785 Berlin, Germany",
  lat: 52.5092,
  lng: 13.3639,
  mapsLink: "https://www.google.com/maps?q=Bauhaus+Archive,+Klingelh%C3%B6ferstra%C3%9Fe+14,+10785+Berlin,+Germany"
},
{
  name: "Photo Museum Ireland",
  address: "Meeting House Square, Temple Bar, Dublin, D02 X406, Ireland",
  mapsLink: "https://www.google.com/maps?q=Photo+Museum+Ireland,+Meeting+House+Square,+Temple+Bar,+Dublin,+D02+X406,+Ireland",
  country: "ireland",
  countryLabel: "Ireland",
  lat: 53.3449,
  lng: -6.2649
},
{
  name: "Analogue Amsterdam",
  address: "Zeedijk 80, 1012 TK Amsterdam, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Analogue+Amsterdam,+Zeedijk+80,+1012+TK+Amsterdam,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 52.3735,
  lng: 4.9004
}, 
{
  name: "Kamera Express Almelo",
  address: "Woonboulevard 36, 7606 JA Almelo, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Almelo,+Woonboulevard+36,+7606+JA+Almelo,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 52.3375,
  lng: 6.6703,
  phone: "+31 546 211 199"
},
{
  name: "Kamera Express Amsterdam",
  address: "Parnassusweg 202-206, 1076 AV Amsterdam, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Amsterdam,+Parnassusweg+202-206,+1076+AV+Amsterdam,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 52.3389,
  lng: 4.8728,
  phone: "+31 20 662 0188"
},
{
  name: "Kamera Express Arnhem",
  address: "Kronenburgsingel 20, 6831 EX Arnhem, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Arnhem,+Kronenburgsingel+20,+6831+EX+Arnhem,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 51.9584,
  lng: 5.9126,
  phone: "+31 26 833 0199"
},
{
  name: "Kamera Express Breda",
  address: "Nieuwe Ginnekenstraat 41, 4811 NN Breda, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Breda,+Nieuwe+Ginnekenstraat+41,+4811+NN+Breda,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 51.5850,
  lng: 4.7795,
  phone: "+31 76 514 4045"
},
{
  name: "Kamera Express Capelle aan den IJssel",
  address: "Rietbaan 5, 2908 LP Capelle aan den IJssel, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Capelle+aan+den+IJssel,+Rietbaan+5,+2908+LP+Capelle+aan+den+IJssel,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 51.9296,
  lng: 4.5748,
  phone: "+31 10 403 5329"
},
{
  name: "Kamera Express Den Bosch",
  address: "Hinthamerstraat 86A, 5211 MS 's-Hertogenbosch, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Den+Bosch,+Hinthamerstraat+86A,+5211+MS+'s-Hertogenbosch,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 51.6889,
  lng: 5.3104,
  phone: "+31 73 614 4848"
},
{
  name: "Kamera Express Den Haag",
  address: "Juliana van Stolberglaan 177, 2595 CD Den Haag, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Den+Haag,+Juliana+van+Stolberglaan+177,+2595+CD+Den+Haag,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 52.0828,
  lng: 4.3248,
  phone: "+31 70 833 0199"
},
{
  name: "Kamera Express Eindhoven",
  address: "Stratumsedijk 32, 5611 NS Eindhoven, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Eindhoven,+Stratumsedijk+32,+5611+NS+Eindhoven,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 51.4347,
  lng: 5.4845,
  phone: "+31 40 833 0199"
},
{
  name: "Kamera Express Groningen",
  address: "Het Hout 204, 9723 LE Groningen, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Groningen,+Het+Hout+204,+9723+LE+Groningen,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 53.2109,
  lng: 6.5906,
  phone: "+31 50 210 2999"
},
{
  name: "Kamera Express Maastricht",
  address: "Plein 1992 25, 6221 JP Maastricht, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Maastricht,+Plein+1992+25,+6221+JP+Maastricht,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 50.8483,
  lng: 5.7015,
  phone: "+31 43 833 0199"
},
{
  name: "Kamera Express Rotterdam",
  address: "Karel Doormanstraat 263, 3012 GH Rotterdam, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Rotterdam,+Karel+Doormanstraat+263,+3012+GH+Rotterdam,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 51.9208,
  lng: 4.4733,
  phone: "+31 10 403 5300"
},
{
  name: "Kamera Express Utrecht",
  address: "Parijsboulevard 4, 3541 CX Utrecht, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Utrecht,+Parijsboulevard+4,+3541+CX+Utrecht,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 52.0909,
  lng: 5.0916,
  phone: "+31 30 833 0199"
},
{
  name: "Kamera Express Zwolle",
  address: "Dijkstraat 49, 8011 XS Zwolle, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Zwolle,+Dijkstraat+49,+8011+XS+Zwolle,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 52.5166,
  lng: 6.0956,
  phone: "+31 38 210 2999"
},
{
  name: "Kamera Express Antwerpen",
  address: "Boomsesteenweg 81, 2610 Antwerpen, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Antwerpen,+Boomsesteenweg+81,+2610+Antwerpen,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 51.1779,
  lng: 4.3927
},
{
  name: "Kamera Express Dilbeek",
  address: "Ninoofsesteenweg 344, 1700 Dilbeek, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Dilbeek,+Ninoofsesteenweg+344,+1700+Dilbeek,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 50.8478,
  lng: 4.2675
},
{
  name: "Kamera Express Brussels Evere",
  address: "Leuvensesteenweg 1084-1086, 1140 Evere, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Brussels+Evere,+Leuvensesteenweg+1084-1086,+1140+Evere,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 50.8838,
  lng: 4.4047
},
{
  name: "Kamera Express Brussels Centre",
  address: "Avenue des Celtes 5, 1040 Brussels, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Brussels+Centre,+Avenue+des+Celtes+5,+1040+Brussels,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 50.8392,
  lng: 4.3892
},
{
  name: "Kamera Express Mechelen",
  address: "Brusselsepoortstraat 9, 2800 Mechelen, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Mechelen,+Brusselsepoortstraat+9,+2800+Mechelen,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 51.0267,
  lng: 4.4787
},
{
  name: "Kamera Express Gent",
  address: "Nieuwevaart 182, 9000 Gent, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Gent,+Nieuwevaart+182,+9000+Gent,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 51.0645,
  lng: 3.7132
},
{
  name: "Kamera Express Liège",
  address: "Boulevard de la Sauvenière 1, 4000 Liège, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Li%C3%A8ge,+Boulevard+de+la+Sauveni%C3%A8re+1,+4000+Li%C3%A8ge,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 50.6436,
  lng: 5.5717
},
{
  name: "Kamera Express Nivelles",
  address: "Rue Johannes Gutenberg 20, 1400 Nivelles, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Nivelles,+Rue+Johannes+Gutenberg+20,+1400+Nivelles,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 50.6058,
  lng: 4.3235
},
{
  name: "Kamera Express Turnhout",
  address: "Everdongenlaan 15 Unit 6/7, 2300 Turnhout, Belgium",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Turnhout,+Everdongenlaan+15+Unit+6%2F7,+2300+Turnhout,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 51.3227,
  lng: 4.9257
},
{
  name: "Kamera Express Braunschweig",
  address: "Münzstraße 14, 38100 Braunschweig, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Braunschweig,+M%C3%BCnzstra%C3%9Fe+14,+38100+Braunschweig,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 52.2659,
  lng: 10.5211
},
{
  name: "Kamera Express Bremen",
  address: "Ostertorsteinweg 79, 28203 Bremen, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Bremen,+Ostertorsteinweg+79,+28203+Bremen,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 53.0724,
  lng: 8.8158
},
{
  name: "Kamera Express Cologne",
  address: "Neumarkt 32-34, 50667 Cologne, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Cologne,+Neumarkt+32-34,+50667+Cologne,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 50.9364,
  lng: 6.9505
},
{
  name: "Kamera Express Frankfurt",
  address: "Hochstraße 49, 60313 Frankfurt am Main, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Frankfurt,+Hochstra%C3%9Fe+49,+60313+Frankfurt+am+Main,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 50.1165,
  lng: 8.6777
},
{
  name: "Kamera Express Hamburg",
  address: "Domstraße 14, 20095 Hamburg, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Hamburg,+Domstra%C3%9Fe+14,+20095+Hamburg,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 53.5488,
  lng: 10.0019
},
{
  name: "Kamera Express Hannover",
  address: "Georgsplatz 10, 30159 Hannover, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Hannover,+Georgsplatz+10,+30159+Hannover,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 52.3680,
  lng: 9.7384
},
{
  name: "Kamera Express Kiel",
  address: "Knooper Weg 25, 24103 Kiel, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Kiel,+Knooper+Weg+25,+24103+Kiel,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 54.3233,
  lng: 10.1349
},
{
  name: "Kamera Express Lübeck",
  address: "Königstraße 129, 23552 Lübeck, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+L%C3%BCbeck,+K%C3%B6nigstra%C3%9Fe+129,+23552+L%C3%BCbeck,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 53.8675,
  lng: 10.6865
},
{
  name: "Kamera Express Munich",
  address: "Zweibrückenstraße 13, 80331 Munich, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Munich,+Zweibr%C3%BCckenstra%C3%9Fe+13,+80331+Munich,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 48.1356,
  lng: 11.5720
},
{
  name: "Kamera Express Stuttgart",
  address: "Tübinger Straße 18, 70178 Stuttgart, Germany",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Stuttgart,+T%C3%BCbinger+Stra%C3%9Fe+18,+70178+Stuttgart,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 48.7728,
  lng: 9.1746
},
  {
  name: "Kamera Express Nivelles",
  address: "Rue Johannes Gutenberg 20, 1400 Nivelles, Belgium",
  mapsLink: "https://www.google.com/maps?q=Rue+Johannes+Gutenberg+20,+1400+Nivelles,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 50.6058,
  lng: 4.3235
},
{
  name: "Kamera Express Turnhout",
  address: "Everdongenlaan 15 Unit 6/7, 2300 Turnhout, Belgium",
  mapsLink: "https://www.google.com/maps?q=Everdongenlaan+15,+2300+Turnhout,+Belgium",
  country: "belgium",
  countryLabel: "Belgium",
  lat: 51.3227,
  lng: 4.9257
},
{
  name: "Kamera Express Braunschweig",
  address: "Münzstraße 14, 38100 Braunschweig, Germany",
  mapsLink: "https://www.google.com/maps?q=Münzstraße+14,+38100+Braunschweig,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 52.2659,
  lng: 10.5211
},
{
  name: "Kamera Express Bremen",
  address: "Ostertorsteinweg 79, 28203 Bremen, Germany",
  mapsLink: "https://www.google.com/maps?q=Ostertorsteinweg+79,+28203+Bremen,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 53.0724,
  lng: 8.8158
},
{
  name: "Kamera Express Cologne",
  address: "Neumarkt 32-34, 50667 Cologne, Germany",
  mapsLink: "https://www.google.com/maps?q=Neumarkt+32-34,+50667+Cologne,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 50.9364,
  lng: 6.9505
},
{
  name: "Kamera Express Frankfurt",
  address: "Hochstraße 49, 60313 Frankfurt am Main, Germany",
  mapsLink: "https://www.google.com/maps?q=Hochstraße+49,+60313+Frankfurt+am+Main,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 50.1165,
  lng: 8.6777
},
{
  name: "Kamera Express Hamburg",
  address: "Domstraße 14, 20095 Hamburg, Germany",
  mapsLink: "https://www.google.com/maps?q=Domstraße+14,+20095+Hamburg,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 53.5488,
  lng: 10.0019
},
{
  name: "Kamera Express Hannover",
  address: "Georgsplatz 10, 30159 Hannover, Germany",
  mapsLink: "https://www.google.com/maps?q=Georgsplatz+10,+30159+Hannover,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 52.3680,
  lng: 9.7384
},
{
  name: "Kamera Express Kiel",
  address: "Knooper Weg 25, 24103 Kiel, Germany",
  mapsLink: "https://www.google.com/maps?q=Knooper+Weg+25,+24103+Kiel,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 54.3233,
  lng: 10.1349
},
{
  name: "Kamera Express Lübeck",
  address: "Königstraße 129, 23552 Lübeck, Germany",
  mapsLink: "https://www.google.com/maps?q=Königstraße+129,+23552+Lübeck,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 53.8675,
  lng: 10.6865
},
{
  name: "Kamera Express Munich",
  address: "Zweibrückenstraße 13, 80331 Munich, Germany",
  mapsLink: "https://www.google.com/maps?q=Zweibrückenstraße+13,+80331+Munich,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 48.1356,
  lng: 11.5720
},
{
  name: "Kamera Express Stuttgart",
  address: "Tübinger Straße 18, 70178 Stuttgart, Germany",
  mapsLink: "https://www.google.com/maps?q=Tübinger+Straße+18,+70178+Stuttgart,+Germany",
  country: "germany",
  countryLabel: "Germany",
  lat: 48.7728,
  lng: 9.1746
},
{
  name: "Kamera Express Luxembourg",
  address: "Avenue Monterey 15, L-2163 Luxembourg",
  mapsLink: "https://www.google.com/maps?q=Kamera+Express+Luxembourg,+Avenue+Monterey+15,+L-2163+Luxembourg",
  country: "luxembourg",
  countryLabel: "Luxembourg",
  lat: 49.6116,
  lng: 6.1296
},
{
  name: "Lomography Embassy Barcelona",
  address: "Carrer d'en Rosic, 3, Ciutat Vella, 08003 Barcelona, Spain",
  mapsLink: "https://www.google.com/maps?q=Lomography+Embassy+Barcelona,+Carrer+d%27en+Rosic,+3,+Ciutat+Vella,+08003+Barcelona,+Spain",
  country: "spain",
  countryLabel: "Spain",
  lat: 41.3840408,
  lng: 2.180876
},
{
  name: "Het Fotovakhuis",
  address: "Generaal Cronjéstraat 21, 2021 JB Haarlem, Netherlands",
  mapsLink: "https://www.google.com/maps?q=Het+Fotovakhuis,+Generaal+Cronj%C3%A9straat+21,+2021+JB+Haarlem,+Netherlands",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 52.3931683,
  lng: 4.6412026
},
{
  name: "Motta art books",
  address: "Grote Berg 70, 5611 KL Eindhoven, Netherlands",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=Motta+art+books&query_place_id=ChIJraGKOgTZxkcROHfAP3XKWTs",
  country: "netherlands",
  countryLabel: "Netherlands",
  lat: 51.435577,
  lng: 5.474315
},
];
